var configJson;
if (process.env.NODE_ENV === 'development') {
  configJson = require('./mewo.desarrollo.config.json')
} else {
  configJson = require('./mewo.produccion.config.json')
}
export { configJson };